import { useState, useEffect } from 'react'
import { useTranslation } from 'next-i18next'

export default function LoadingMessages() {
  const { t } = useTranslation(['login'])
  const loadingMessages = t('loading-messages', {
    returnObjects: true
  }) as string[]

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex(
        (prevIndex) => (prevIndex + 1) % loadingMessages.length
      )
    }, 3000)

    return () => clearInterval(interval)
  }, [loadingMessages.length])

  return (
    <h4
      className="mt-1 text-[1.15rem] text-center"
      dangerouslySetInnerHTML={{
        __html: loadingMessages[currentMessageIndex]
      }}
    />
  )
}
